(function ($, Drupal, drupalSettings) {
  'use strict';

  Drupal.behaviors.mapEmbed = {
    attach: function (context, settings) {
      var mapWrapper = $('.map-container');
      mapWrapper.click(function () {
        $(this).find('iframe').addClass('clicked');
      });

      mapWrapper.mouseleave(function () {
        $(this).find('iframe').removeClass('clicked');
      });
    }
  };

})(jQuery, Drupal, drupalSettings);
